<template>
    <span class="block">
        <file-preview
            v-for="file in files"
            :key="file.id"
            :file="file"
            :interactive="false"
            @open="open"
        ></file-preview>
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { GridComponent } from '@src/Common/Components/types';
import FilePreview from '@src/Fields/Pages/Files/FilePreview.vue';

const props = withDefaults(defineProps<GridComponent>(), {});

const files = computed(() => {
    return props.value ? (Array.isArray(props.value) ? props.value : [props.value]) : [];
});

const open = (file: any): void => {
    console.log(file);

    if (file.id) {
        window.open(file.url, '_blank');
    }
};
</script>
